import React, { ChangeEvent, FC, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { PERSONAL_NUMBER } from '~/actions/actionTypes';
import { setInvalidError, setMissingError } from '~/actions/errorActions';
import { setInput, validateValue } from '~/actions/formActions';
import { IState } from '~/sharedInterfaces/IState';
import { IBaseInput } from '~/sharedInterfaces/SharedInterfaces';
import { IBaseComponent } from '../../sharedInterfaces/IBaseComponent';
import Input from '../Base/Input/Input';
import { Market } from '~/sharedInterfaces/SharedEnums';
import { isValidPersonalNumber } from '~/utils/validators';
import { getPersonalNumberPlaceholder } from '~/services/GetPlaceholderService';

export interface IPersonalNumber extends IBaseInput {}
export interface IPersonalNumberProps extends IPersonalNumber, IBaseComponent {}

const PersonalNumber: FC<IPersonalNumberProps> = (props: IBaseComponent) => {
  const dispatch = useDispatch();

  const value = useSelector((state: IState) => state.onboarding.personalNumber || '');
  const error = useSelector((state: IState) => state.error.personalNumber);
  const { locale } = useSelector((state: IState) => state.widgetContext);
  const { market } = useSelector((state: IState) => state.widgetContext.settings);

  const handleOnChange = (event: ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value;

    dispatch(setInput(PERSONAL_NUMBER, inputValue));
    if (error?.missing) dispatch(setMissingError(PERSONAL_NUMBER, ''));
  };

  const handleValidation = () => {
    if (market === Market.Belgium) {
      const BEValue = value
        .replace(/$|-|\./g, '')
        .replace(/(\d{2})(\d{2})(\d{2})(\d{3})(\d{2})/, '$1.$2.$3-$4.$5');
      dispatch(setInput(PERSONAL_NUMBER, BEValue));
    }

    dispatch(validateValue(isValidPersonalNumber, PERSONAL_NUMBER, value, locale));
  };

  useEffect(() => {
    const validPersonalNumber = isValidPersonalNumber(value, props.settings.market);
    if (validPersonalNumber && error?.invalid) dispatch(setInvalidError(PERSONAL_NUMBER, ''));
  }, [value]);

  return (
    <Input
      {...props}
      value={value}
      error={error?.missing || error?.invalid}
      onChange={handleOnChange}
      handleValidation={handleValidation}
      analyticsEvent="personal-number"
      placeholder={getPersonalNumberPlaceholder(locale)}
    />
  );
};

export default PersonalNumber;
